import EnquiryForm from './components/EnquiryForm';

const THANK_YOU_URL = 'https://atlanticgroup.com.au/thank-you/';

export default function App() {
  // After a successful submission (both Event and Media & Employment enquiries),
  // send the visitor to the website's thank-you page. Uses the top window so
  // the redirect also works when the form is embedded in a frame.
  const handleSuccess = () => {
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = THANK_YOU_URL;
        return;
      }
    } catch (error) {
      // Cross-origin frame access blocked — fall back to opening at top level.
      console.error('Top-level redirect blocked, falling back:', error);
      window.open(THANK_YOU_URL, '_top');
      return;
    }
    window.location.href = THANK_YOU_URL;
  };

  return <EnquiryForm onSuccess={handleSuccess} />;
}
